import { type FC, type HTMLAttributes } from 'react';
import UpgradeArrow from '@assets/img/icons/upgrade-single-arrow.svg?react';

import styles from './styles.module.scss';

const UpgradeGreenArrowsAnimation: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div className={`flex flex-col -space-y-2 ${className || ''}`} {...props}>
      <UpgradeArrow className={styles.arrowAnimation} />
      <UpgradeArrow className={styles.arrowAnimation} />
      <UpgradeArrow className={styles.arrowAnimation} />
    </div>
  );
};

export default UpgradeGreenArrowsAnimation;
